var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCompliance = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_5102",
    "data-name": "Group 5102",
    width: 25.561,
    height: 34.324,
    viewBox: "0 0 25.561 34.324",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_Check_1141128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5064",
    "data-name": "Group 5064",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5053",
    "data-name": "Group 5053",
    transform: "translate(0 4.829)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19178",
    "data-name": "Path 19178",
    d: "M32.235,36.995H10.326A1.794,1.794,0,0,1,8.5,35.239V9.256A1.794,1.794,0,0,1,10.326,7.5h5.112v.7H10.326a1.076,1.076,0,0,0-1.1,1.053V35.239a1.076,1.076,0,0,0,1.1,1.053H32.235a1.076,1.076,0,0,0,1.1-1.053V9.256a1.076,1.076,0,0,0-1.1-1.053H27.108V7.5h5.127a1.794,1.794,0,0,1,1.826,1.756V35.239A1.794,1.794,0,0,1,32.235,36.995Z",
    transform: "translate(-8.5 -7.5)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5054",
    "data-name": "Group 5054",
    transform: "translate(4.005 11.749)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19179",
    "data-name": "Path 19179",
    d: "M13.882,19.841,12.646,18.6l.376-.376.892.892,3.006-2.5.341.408Z",
    transform: "translate(-12.646 -16.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5066",
    "data-name": "Group 5066",
    transform: "translate(4.005 17.544)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19179-2",
    "data-name": "Path 19179",
    d: "M13.882,19.841,12.646,18.6l.376-.376.892.892,3.006-2.5.341.408Z",
    transform: "translate(-12.646 -16.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5067",
    "data-name": "Group 5067",
    transform: "translate(4.005 24.305)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19179-3",
    "data-name": "Path 19179",
    d: "M13.882,19.841,12.646,18.6l.376-.376.892.892,3.006-2.5.341.408Z",
    transform: "translate(-12.646 -16.616)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5060",
    "data-name": "Group 5060",
    transform: "translate(10.141 13.522)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2143",
    "data-name": "Rectangle 2143",
    width: 12.556,
    height: 0.483,
    rx: 0.241,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5061",
    "data-name": "Group 5061",
    transform: "translate(10.141 19.317)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144",
    "data-name": "Rectangle 2144",
    width: 12.556,
    height: 0.483,
    rx: 0.241,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5068",
    "data-name": "Group 5068",
    transform: "translate(10.141 26.078)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2144-2",
    "data-name": "Rectangle 2144",
    width: 12.556,
    height: 0.483,
    rx: 0.241,
    transform: "translate(0 0)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5063",
    "data-name": "Group 5063",
    transform: "translate(6.383)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19182",
    "data-name": "Path 19182",
    d: "M30.364,9.059H17.5V5.779a1.86,1.86,0,0,1,1.892-1.822h2.147a.826.826,0,0,0,.713-.473,1.927,1.927,0,0,1,3.361,0,.826.826,0,0,0,.713.473h2.147a1.86,1.86,0,0,1,1.892,1.822ZM18.257,8.33H29.608V5.779a1.116,1.116,0,0,0-1.135-1.093H26.326a1.572,1.572,0,0,1-1.385-.866,1.156,1.156,0,0,0-2.017,0,1.572,1.572,0,0,1-1.385.866H19.392a1.116,1.116,0,0,0-1.135,1.093Z",
    transform: "translate(-17.5 -2.5)",
    fill: "#fff"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCompliance, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Compliance.bb0ce5a0.svg";
export { ForwardRef as ReactComponent };